import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mouse-scroll-icon",
  "use": "mouse-scroll-icon-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" id=\"mouse-scroll-icon\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M20.931 11.638l2.121 2.121-8.405 8.405-2.116 2.126-.005-.005-2.126-2.116.005-.005L2 13.759l2.121-2.121 8.405 8.405 8.405-8.405z\" /><path d=\"M20.931 1l2.121 2.121-8.405 8.405-2.116 2.126-.005-.005-2.126-2.116.005-.005L2 3.121 4.121 1l8.405 8.405L20.931 1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol